import Event from '../../core/Event';

export default class OrderProductsNextRequested extends Event {
    public static type = 'OrderProductsNextRequested';

    constructor() {
        super(OrderProductsNextRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/OrderProductsNextRequested.ts